"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
exports.SharedModule = SharedModule;
